// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DCZR","top":"styles_top__1deev"};